import { createContext } from "react";

let AuthContext = createContext();

export default AuthContext;
